import { render, staticRenderFns } from "./MonitorYSY.vue?vue&type=template&id=72445d66&scoped=true&"
import script from "./MonitorYSY.vue?vue&type=script&lang=js&"
export * from "./MonitorYSY.vue?vue&type=script&lang=js&"
import style0 from "./MonitorYSY.vue?vue&type=style&index=0&id=72445d66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72445d66",
  null
  
)

export default component.exports